import { render, staticRenderFns } from "./EspecificacionData.vue?vue&type=template&id=cb3b728e&"
import script from "./EspecificacionData.vue?vue&type=script&lang=js&"
export * from "./EspecificacionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports